var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vc-progress-bar',{attrs:{"waiting-time":_vm.limitTime,"is-complete":_vm.isComplete}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }